import clsx from "clsx";
import { ReactNode, useContext } from "react";
import "./Layout.css";
import { Outlet, useLocation } from "react-router-dom";
import { MediaTablet } from "../../../api/const/MediaQuery";
import useMediaQuery from "../../../hook/useMediaQuery";
import { DropdownMenu, Modal, Navbar } from "../../molecules";
import AsideMenu from "../../molecules/AsideMenu/AsideMenu";
import { AppGeneralContext } from "../../../shared/GeneralContext/GeneralContext";
import { ModalType, initialStateModal } from "../../types/types";
import { DatesModal } from "components/pagine/DatesModal";
import { SelectDates } from "components/pagine";
import { useAuth } from "shared/auth";

type TemplatesProps = {
  isPlatform: boolean;
};

export const Layout = ({ isPlatform }: TemplatesProps) => {
  const tablet = useMediaQuery(MediaTablet);
  const { modal, setModal, modalDatesIsOpen, setModalDatesIsOpen } = useContext(AppGeneralContext);
  const { auth} = useAuth()
  const location = useLocation()
  return (
   <>
        <div className="w-100 h-100 m-0 p-0 d-flex flex-row   " >
            <header className={clsx("position-relative  d-flex flex-column justify-content-between  m-0 ",
                { "header-platform ps-4 pe-2": !location.pathname.toLowerCase().includes(`services/`) && !tablet && isPlatform },
                { "header-website pe-0 ps-0": tablet || !isPlatform },
                {"header-platform pe-0 ps-0" : location.pathname.toLowerCase().includes(`services/`) && !tablet && isPlatform} )}>
           
               {isPlatform && !tablet ? 
                <div className="pt-2 pb-2 navbar-background-platform" >
                    <Navbar />
                    <div className={"position-relative  "}>
                        <DropdownMenu isPlatform={isPlatform} />
                    </div>
                </div>
                :
                
                <div className="pt-2 pb-2 navbar-background" >
                    <Navbar />
                    <div className={"position-relative  "}>
                        <DropdownMenu isPlatform={isPlatform} />
                    </div>
                </div>
                }

               
                <div className={clsx("  h-100 p-0 d-flex justify-content-center w-100  ",
                { "" : !isPlatform},
                 {"mt-0" : isPlatform },
                 {"overflow-y" : tablet},
                 {"cover" : location.pathname.toLowerCase().includes(`services/`)} )}>
                    <div className={clsx(" w-100 h-100  ",
                        { "outlet-max-width": !location.pathname.toLowerCase().includes(`services/`) && !tablet },
                        { "ms-2 me-2 ":!location.pathname.toLowerCase().includes(`services/`) && tablet },
                        { "" : location.pathname.toLowerCase().includes(`services/`) && !tablet},
                        { "" : location.pathname.toLowerCase().includes(`services/`) && tablet}
                    )}>
                         <div className="spaceNavbar"/>
                        <Outlet />
                    </div>
                </div>
            </header>
            {!tablet && isPlatform &&
            <>
                <div className={clsx("aside   h-100  m-0 p-0 position relative",
                {"aside-primary " : !auth?.jwtToken },
                {"aside-bg" : auth?.jwtToken})}
                  >
                   {auth?.jwtToken && <AsideMenu />}
                </div>
                </>
            }
            </div>
      </>
  );
};
